
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-24 15:16:03
-->
<template>
  <el-drawer
    :title="item.id ? '编辑角色' : '添加角色'"
    :visible.sync="visibleTwo"
    @closed="closeTwo"
     :size="width<=720?'90%':'500px'"
    :with-header="true"
    class="box"
    :wrapperClosable="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :label-width="width<=720?'120px':'110px'"
      class="demo-ruleForm"
    >
      <el-form-item label="所属组织" prop="organizationId">
        <TreeSelect
          :record="ruleForm"
          @selectpart="selectpart"
          :resData="listDataTwo"
          v-if="visibleTwo"
        ></TreeSelect>
      </el-form-item>
      <el-form-item label="角色名称" prop="roleName">
        <el-input
          v-model="ruleForm.roleName"
          placeholder="请输入角色名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" class="remark">
        <el-input
          :rows="4"
          type="textarea"
          placeholder="请输入备注"
          v-model="ruleForm.remark"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="btnShow" class="bottom">
        <div class="form-bottom">
          <el-button size="medium" @click="closeTwo">取消</el-button>
          <el-button size="medium" :loading="loading" type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { create, update } from "./role_management";
import TreeSelect from "@/components/tree_selection.vue";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
export default {
  data() {
    return {
      ruleForm: {
        organizationId: "",
        roleName: "",
        remark: "",
        id: "",
      },
      loading:false,
      visibleTwo:false,
      listDataTwo: [],
      rules: {
        organizationId: [
          { required: true, message: "请输入活动名称", trigger: "change" },
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      btnShow:true,
      width:'',
    };
  },
  props: ["visible", "item", "listData"],
  methods: {
    submit() {
      const that = this;
      this.loading = true;
       this.$refs.ruleForm.validate((valid) => {
          if(valid){
              if (this.item.id) {
                this.ruleForm.id = this.item.id;
                update(this.ruleForm).then((res) => {
                  if (res.code == 0) {
                    that.close();
                  }
                  this.loading = false;
                });
              } else {
                create(this.ruleForm).then((res) => {
                  if (res.code == 0) {
                    that.close();
                  }
                  this.loading = false;
                });
              }
          }else{
              this.loading = false;
          }
       })
      
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    close() {
      this.$emit("close");
    },
    closeTwo(){
      this.$emit("closeTwo");
    },
    selectpart(item) {
      this.ruleForm.organizationId = item.value;
    },
  },
  watch: {
    visible(val) {
      this.visibleTwo = val;
      this.listDataTwo = this.listData;
       this.getKeyboardState()
          this.width = document.documentElement.clientWidth;
                window.onresize = () => {
                    return (() => {
                        this.width  = document.documentElement.clientWidth;
                    })();
                    };
      if (this.item.id) {
        this.ruleForm = {
          organizationId: this.item.organizationId,
          organizationName: this.item.organizationName,
          parentId: this.item.organizationId,
          remark: this.item.remark,
          roleName: this.item.roleName,
        };
      }else{
        this.ruleForm = JSON.parse(JSON.stringify({ organizationId: "",
        roleName:'',
        remark:'',
        id:''}))
      }
    },
  },
  created() {},
  components: {
    TreeSelect,
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.el-button--primary {
  background: #176de6;
}
</style>